module.exports = __webpack_public_path__ + "img/logo-h-small.33d96f19.png";